export default __webpack_public_path__ + "static/media/occelerator-bg.0b847162.svg";